import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// import moment from "moment"

import { Grid, Dialog, Button, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './modalDatosIniciales.css';

import { iniChangeDesLarga, iniChangeDesLargaTitle } from '../../../redux/actions/pptos';
import { AutocompleteContacts } from '../../compras/form/AutocompleteContacts';
// import NumberFormat from 'react-number-format';
import { Model } from '../../../models/model';

export const DialogDetailItems = ({ open, setOpen, item }) => {
    // console.log('--item ppto--', item)

    const dispatch = useDispatch();
    const { items } = useSelector(state => state.ppto.detail)

    // console.log({ items })

    const [form, setForm] = useState({
        ...item,
        total_proyectado: item?.total_proyectado || 0,
        saldo_por_proyectar: item?.saldo_por_proyectar || 0
    });

    const handleGetInfoItem = useCallback(async (id) => {

        const results = await Model.getOne({
            url: `budgets-items/${id}`,
        })

        if (results) {
            setForm(prev => ({
                ...prev,
                total_proyectado: results?.total_proyectado || 0,
                saldo_por_proyectar: results?.saldo_por_proyectar || 0
            }))
        }

    }, [])

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        });
    }

    const handleChangeProveedor = (proveedor) => {
        setForm({
            ...form,
            'id_proveedor': proveedor.id_proveedor,
        });
    }

    // const handleChangeDate = (newValue) => {
    //     setForm({
    //         ...form,
    //         fecha_vencimiento: newValue
    //     })
    // }

    const handleChangeChecked = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.checked
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (item.tipo === 'title') {
            dispatch(iniChangeDesLargaTitle(items, form, item))
        } else {
            dispatch(iniChangeDesLarga(items, form, item))
        }

        toast.success('Detalle actualzado');
        setOpen(false)
    }

    useEffect(() => {
        handleGetInfoItem(item.id)
    }, [item.id, handleGetInfoItem])

    return (
        <Dialog
            className='dialogoCrearPresupuesto'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    <span style={{ textTransform: 'uppercase', fontSize: '16px' }}>{form.nombre}</span>
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <FormDescription
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleChangeProveedor={handleChangeProveedor}
                    handleChangeChecked={handleChangeChecked}
                    form={form}
                />

                {/* {form.tipo === 'item' ?
                    <FormDescription
                        handleSubmit={handleSubmit}
                        handleChange={handleChange}
                        handleChangeProveedor={handleChangeProveedor}
                        form={form}
                    />
                    :
                    <FlowSection
                        form={form}
                        setForm={setForm}
                        handleGetInfoItem={handleGetInfoItem}
                    />
                } */}

            </div>
        </Dialog>
    )
}

const FormDescription = ({ handleSubmit, handleChange, handleChangeProveedor, handleChangeChecked, form }) => {
    return (
        <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>
            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        name="descripcion_larga"
                        label="Descripción"
                        multiline
                        rows={6}
                        value={form.descripcion_larga}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <AutocompleteContacts
                        dataForm={form}
                        id_proveedor={form?.id_proveedor}
                        handleChangeProveedor={handleChangeProveedor}
                    />
                </Grid>
                <Grid item xs={12}>
                    <label className='flex'>
                        <input
                            type="checkbox"
                            name="sin_impuesto"
                            checked={form?.sin_impuesto || false}
                            className='p-normal-checkbox'
                            onChange={handleChangeChecked}
                        />
                        <span className='ms-2'>Sin impuestos</span>
                    </label>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        name="descripcion_interna"
                        label="Nota interna (no se muestra en pdf)"
                        multiline
                        rows={6}
                        value={form.descripcion_interna}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>

            <div style={{ marginTop: '27px', textAlign: 'right' }}>
                <Button
                    id="id-button-save-ppto"
                    className='p-btn-primary'
                    variant="contained"
                    size='medium'
                    type='submit'
                >
                    Guardar
                </Button>
            </div>

        </form>
    )
}

// const FlowSection = ({ form, setForm, handleGetInfoItem }) => {

//     const { id: id_ppto, id_cliente } = useSelector(state => state.ppto.detail)
//     const [flowsList, setFlowsList] = useState([])
//     const [initialFlowsList, setInitialFlowsList] = useState([])
//     const [hitosList, setHitosList] = useState([])

//     useEffect(() => {
//         handleGetFlows()
//     }, [])

//     useEffect(() => {
//         handleGetHitosTasks()
//     }, [])

//     const handleGetFlows = async () => {

//         const filters = {
//             id_ppto: id_ppto,
//             id_item: form.id
//         }

//         const params = (new URLSearchParams(filters)).toString()
//         const results = await Model.getAll({
//             url: `reports/projections/items/?${params}`,
//         })

//         console.log({ results })
//         setFlowsList(results)
//         setInitialFlowsList(results)

//     }

//     const handleGetHitosTasks = async () => {

//         const resultsHitos = await Model.getAll({
//             url: `tasks/hitos/byppto/${id_ppto}`,
//         })

//         console.log({ resultsHitos })
//         setHitosList(resultsHitos)

//     }

//     const handleAdd = () => {
//         const newId = flowsList?.length + 1

//         const newFlow = {
//             id: newId,
//             porcentaje_flow: 0,
//             monto_neto: 0,
//             fecha_proyeccion: moment(new Date()).format('YYYY-MM-DD'),
//             id_tarea: null,
//             saved: false
//         }

//         setFlowsList([...flowsList, newFlow])
//     }

//     const handleChangeNumber = async (values, id) => {
//         if (!values.sourceInfo.event) return false

//         const totalItem = parseFloat(form.precio_subtotal)
//         const newListUpdate = flowsList.map(flo => {
//             if (flo.id === id) {
//                 return {
//                     ...flo,
//                     monto_neto: values.floatValue,
//                     porcentaje_flow: (values.floatValue / totalItem) * 100
//                 }
//             }

//             return flo
//         })

//         setFlowsList(newListUpdate)
//         await calBalances(newListUpdate)

//     }

//     const handleChangeNumberPercent = async (values, id) => {
//         if (!values.sourceInfo.event) return false

//         const totalItem = parseFloat(form.precio_subtotal)
//         const newListUpdate = flowsList.map(flo => {
//             if (flo.id === id) {
//                 return {
//                     ...flo,
//                     porcentaje_flow: values.floatValue,
//                     monto_neto: (values.floatValue / 100) * totalItem
//                 }
//             }

//             return flo
//         })

//         setFlowsList(newListUpdate)
//         await calBalances(newListUpdate)

//     }

//     const handleChangeHito = async ({ target }, id) => {
//         const hitoId = target.value
//         const infoHito = hitosList.find(hi => hi.id === hitoId)

//         const newListUpdate = flowsList.map(flo => {
//             const fecha = infoHito ? moment(infoHito.fecha_fin).format('YYYY-MM-DD') : flo.fecha_proyeccion

//             if (flo.id === id) {
//                 return {
//                     ...flo,
//                     [target.name]: hitoId,
//                     fecha_proyeccion: fecha
//                 }
//             }

//             return flo
//         })

//         setFlowsList(newListUpdate)

//     }

//     const calBalances = async (flowsUpdate, returnValue = false) => {
//         let sumTotal = 0

//         for (let x = 0; x < flowsUpdate.length; x++) {
//             sumTotal = sumTotal + parseFloat(flowsUpdate[x].monto_neto)
//         }

//         const newValues = {
//             total_proyectado: sumTotal,
//             saldo_por_proyectar: parseFloat(form.precio_subtotal) - parseFloat(sumTotal || 0)
//         }

//         setForm({
//             ...form,
//             ...newValues
//         })

//         if (returnValue) {
//             return newValues
//         }

//     }

//     const handleRemove = async (id) => {
//         const newListUpdate = flowsList.filter(flo => flo.id !== id)
//         setFlowsList(newListUpdate)

//         const returnValue = true
//         const totalValues = await calBalances(newListUpdate, returnValue)

//         await Model.delete({
//             url: `reports/projections/delete/flow/${id}`,
//             dataForm: {
//                 id_item: form.id,
//                 id_ppto: id_ppto,
//                 id_contacto: id_cliente,
//                 total_proyectado: totalValues?.total_proyectado || 0,
//                 saldo_por_proyectar: totalValues?.saldo_por_proyectar || 0
//             }
//         })

//     }

//     const handleSave = async () => {

//         await Model.update({
//             url: 'reports/projections/items/flow',
//             dataForm: {
//                 id_item: form.id,
//                 id_ppto: id_ppto,
//                 id_contacto: id_cliente,
//                 total_proyectado: form.total_proyectado,
//                 saldo_por_proyectar: form.saldo_por_proyectar,
//                 total_item_ppto: form?.precio_subtotal,
//                 flows: flowsList
//             }
//         })

//         setInitialFlowsList(flowsList)
//         await handleGetInfoItem(form.id)

//     }

//     return (
//         <div>
//             <h3 className='mt-3' style={{ fontSize: '16px' }}>Proyección de flujos:</h3>

//             <div>
//                 <div>
//                     <label style={{ fontWeight: 'bold' }}>Total ítem:</label>
//                     <NumberFormat
//                         style={{ fontSize: '13px' }}
//                         displayType={'text'}
//                         name="total_item"
//                         className="text-end p-w-100 ms-1"
//                         value={form?.precio_subtotal || 0}
//                         thousandSeparator=','
//                         decimalSeparator='.'
//                         prefix='S/ '
//                         decimalScale={2}
//                         fixedDecimalScale={2}
//                     />
//                 </div>
//                 <div>
//                     <label style={{ fontWeight: 'bold' }}>Total proyectado:</label>
//                     <NumberFormat
//                         style={{ fontSize: '13px' }}
//                         displayType={'text'}
//                         name="total_item"
//                         className="text-end p-w-100 ms-1"
//                         value={form?.total_proyectado || 0}
//                         thousandSeparator=','
//                         decimalSeparator='.'
//                         prefix='S/ '
//                         decimalScale={2}
//                         fixedDecimalScale={2}
//                     />
//                 </div>
//                 <div>
//                     <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
//                     <NumberFormat
//                         style={{ fontSize: '13px' }}
//                         displayType={'text'}
//                         name="total_item"
//                         className="text-end p-w-100 ms-1"
//                         value={form?.saldo_por_proyectar || 0}
//                         thousandSeparator=','
//                         decimalSeparator='.'
//                         prefix='S/ '
//                         decimalScale={2}
//                         fixedDecimalScale={2}
//                     />
//                 </div>

//             </div>

//             <div className='d-flex justify-content-between'>
//                 <button
//                     className="btn btn-link btn-sm p-mini-link p-fs-14 mt-1"
//                     onClick={handleAdd}
//                 >
//                     + Agregar flujo de ingreso
//                 </button>

//                 {(JSON.stringify(initialFlowsList) !== JSON.stringify(flowsList)) ?
//                     <button
//                         style={{ width: '150px', margin: '10px' }}
//                         className='btn p-btn-primary'
//                         onClick={handleSave}
//                     >Guardar cambios</button>
//                     : ''
//                 }

//             </div>

//             {flowsList?.length === 0 ?
//                 <h5 style={{
//                     fontSize: '15px',
//                     marginLeft: '10px',
//                     marginTop: '30px'
//                 }}>No hay flujos proyectados.</h5>
//                 :
//                 <table className="table tablesUI mt-1">
//                     <thead>
//                         <tr>
//                             <th className='title text-end'>%</th>
//                             <th className='title text-end'>Monto</th>
//                             <th className='title text-end'>Fecha estimada</th>
//                             <th className='title text-center'>Hito</th>
//                             <th className='title text-end'></th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {flowsList?.map(flo => (
//                             <tr key={flo.id}>
//                                 <td>
//                                     <NumberFormat
//                                         style={{ width: '70px' }}
//                                         className="text-end p-cantidades-item-new2"
//                                         name="porcentaje_flow"
//                                         value={flo?.porcentaje_flow || 0}
//                                         thousandSeparator=','
//                                         decimalSeparator='.'
//                                         suffix="%"
//                                         decimalScale={2}
//                                         fixedDecimalScale={2}
//                                         onValueChange={(values, sourceInfo) => handleChangeNumberPercent({ ...values, sourceInfo }, flo.id)}
//                                     />
//                                 </td>
//                                 <td>
//                                     <NumberFormat
//                                         className="text-end p-cantidades-item-new2"
//                                         style={{ width: '150px' }}
//                                         name="monto_neto"
//                                         value={flo?.monto_neto || 0}
//                                         thousandSeparator=','
//                                         decimalSeparator='.'
//                                         prefix='S/ '
//                                         decimalScale={2}
//                                         fixedDecimalScale={2}
//                                         onValueChange={(values, sourceInfo) => handleChangeNumber({ ...values, sourceInfo }, flo.id)}
//                                     />
//                                 </td>
//                                 <td>{moment(flo.fecha_proyeccion).format('DD-MM-YYYY')}</td>
//                                 <td>
//                                     <select
//                                         style={{
//                                             border: '1px solid lightgray',
//                                             padding: '2px',
//                                             backgroundColor: 'white',
//                                             width: '150px',
//                                             borderRadius: '3px',
//                                             textAlign: 'left'
//                                         }}
//                                         name="id_tarea"
//                                         onChange={(e) => handleChangeHito(e, flo.id)}
//                                     >
//                                         <option key="" value="">--</option>
//                                         {hitosList?.map(hi => (
//                                             <option
//                                                 key={hi.id}
//                                                 selected={hi.id === flo?.id_tarea ? 'selected' : ''}
//                                                 value={hi.id}
//                                             >
//                                                 {hi.nombre}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </td>
//                                 <td>
//                                     <i
//                                         className="bi bi-trash"
//                                         style={{ cursor: 'pointer' }}
//                                         onClick={() => handleRemove(flo.id)}
//                                     ></i>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table >

//             }


//         </div>
//     )
// }